module.exports = __webpack_public_path__ + "static/media/country-logo.9b99cf1a.png";